export default __webpack_public_path__ + "static/media/Gruesome_4.2350e1d4.jpg";